<template lang="html">
  <BaseLoading :spinning="coachLoading" size="large">
    <EditForm :resource="coach" />
  </BaseLoading>
</template>

<script>
import EditForm from "./form";
const COACH_STORE_KEY = "coachStore";
import { mapGetters } from "vuex";

export default {
  components: {
    EditForm
  },
  created() {
    this.dispatcher();
  },
  computed: {
    ...mapGetters({
      coach: `${COACH_STORE_KEY}/coach`,
      coachLoading: `${COACH_STORE_KEY}/coachLoading`
    }),
    coachId() {
      return this.$route.params["id"];
    }
  },
  methods: {
    async dispatcher() {
      await this.$store.dispatch(`${COACH_STORE_KEY}/getCoach`, {
        id: this.coachId
      });
    }
  }
};
</script>

<style lang="sass" scoped></style>
